module.exports = __webpack_public_path__ + "static/assets/31f212395be821de9307a65cb55829cc.png";